import React, {Component} from "react";
import "./assets/scss/SearchReportSettings.scss";
import * as prosConnect from "../prodect/ProsConnect"
import {
    formatDate, getEndOfWorkingDayTime,
    isProsStringEmpty,
    ProsUpdateInfo,
    strYesNoValue, MS_IN_DAY, adjustDateToClock
} from "../prodect/ProsCommonUi";
import {
    prosNotificationShow,
    prosPopupClose,
    prosPopupOpen,
} from "../prodect/ProsPopup";
import {
    ATTR_IS_PRIVATE,
    ATTR_OBJ_TYPE,
    ATTR_EXPIRATION_FILTER,
    ATTR_CREATED_BY,
    STR_NO_VALUE,
    RELATIVE_PREFIX_BEFORE,
    RELATIVE_PREFIX_AFTER,
    ATTR_CREATED_MS_I,
    ATTR_EXPIRATION,
    ATTR_UPDATED_MS_I,
    OBJ_TYPE_LST_SEARCH_R, OBJ_TYPE_LST_SEARCH, currentTimeMs, ATTR_FILTER_UPDATED_AFTER, ATTR_FILTER_UPDATED_BEFORE
} from "../prodect/ProsConnect";
import {ATTR_FILTER_CREATED_AFTER, ATTR_FILTER_CREATED_BEFORE}  from "../prodect/ProsConnect";
import {isProsStrTrue, utcToLocalTime} from "../prodect/ProsConnect";
import Calendar from "react-calendar";
import {MIN_EXPIRE_TIME_MS} from "../prodect/ProsConnect";
import {ATTR_STAG_CH, ATTR_STAG} from "../prodect/ProsConnect";
import {setHelpContext} from "../prodect/HelpManager";
import AccordionDropdown from "../components/AccordionDropdown";
import DropdownMenu from "../components/DropdownMenu";
import Checkbox from "../components/Checkbox";
import Spacer from "../components/Spacer";
import ToggleSwitch from "../components/ToggleSwitch";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import TextInput from "../components/TextInput";


function getOption(tag, i, attr) {
    let projectOption = tag.options.find(option => option.optionIndex === i)
    if (projectOption && projectOption.hasOwnProperty(attr)) {
        return projectOption[attr]
    }
    return 'No label for TAG:' + tag.stag + '/' + i;
}

export default class SearchReportSettings extends Component {

    projectOnOffTags = undefined;
    projectRgTags = undefined;

    constructor(props) {
        super(props);
        this.search = {}
        this.showAdvancedSettings = false
        this.state = {
            projectName: "",
            onOffTags: [],
            rgTags: [],
            searchReportName: "",
            filterByExpiration: false,
            isPrivate: false,
            datePickerTag: undefined,
            datePickerTitle: "",
            refTime: undefined,
            searchFound: false,
            creationDateStart: null,
            creationDateEnd: null,
            modifiedDateStart: null,
            modifiedDateEnd: null,
            expireDateStart: null,
            expireDateEnd: null,
        };
    }

    async componentDidMount() {
        let project = prosConnect.getActiveProject();
        if (project && project.isProjectLoaded()) {
            if (prosConnect.hasPermissionTo("editProject", undefined, undefined, false)) {
                if (this.getSearchSettings(project)) {
                    this.setState({searchFound: true});
                } else {
                    // should not happen - just in case
                    prosNotificationShow(this, 'Hakuraporttia ei löydy', 'warning', true);
                }
            }
        } else {
            // should not happen - just in case
            prosNotificationShow(this, 'Ei projektia?', 'warning', true);
        }
        setHelpContext('search')
    }

    getOnOffSearchSelections(project, search) {
        this.projectOnOffTags = project.getOnOffContent();
        let onOffTags = search ? project.getOnOffContent(search) : prosConnect.getEmptyTags();
        // Remove from search TAG_CH that do not exists in project
        onOffTags.tags = onOffTags.tags.filter(tag => this.projectOnOffTags.tags.find (ptag => ptag.stag === tag.stag));
        // add missing ones
        let maxInd = 0;
        this.projectOnOffTags.tags.forEach(ptag => {
            let ind = parseInt(ptag.stag.replace(ATTR_STAG_CH, ''));
            if (maxInd < ind) { maxInd = ind }
            let searchReportTag = onOffTags.tags.find(stag => stag.stag === ptag.stag);
            if (!searchReportTag) {
                onOffTags.tags.push({
                    stag: ptag.stag,
                    inUse: false,
                    opt2: false,
                    limitedEdit: false,
                });
            }
        });
        onOffTags.maxInd = maxInd;
        this.setState({onOffTags: onOffTags});
    }

    getMultiValueSearchSelections(project, search) {
        this.projectRgTags = project.getMultiValueContent();
        let rgTags = search ? project.getMultiValueContent(search) : prosConnect.getEmptyTags();
        // Remove from search TAG that do not exists in project
        rgTags.tags = rgTags.tags.filter( tag => this.projectRgTags.tags.find(ptag => ptag.stag === tag.stag));
        // Add missing ones
        let maxInd = 0;
        this.projectRgTags.tags.forEach(ptag => {
            let ind = parseInt(ptag.stag.replace(ATTR_STAG, ''));
            if (maxInd < ind) { maxInd = ind }
            let searchReportTag = rgTags.tags.find(rgtag => rgtag.stag === ptag.stag);
            if (searchReportTag) {
                let optionCountDiff = searchReportTag.options.length - ptag.options.length;
                if (optionCountDiff < 0) {
                    // console.log('Add to search', ptag.stag, -optionCountDiff);
                    for (let i = 0; i < -optionCountDiff; i++) {
                        searchReportTag.options.push({
                            inUse: false,
                            opt2: false,
                            limitedEdit: false,
                        })
                    }
                } else if (optionCountDiff > 0) {
                    // console.log('Remove from search tail', ptag.stag, optionCountDiff);
                    searchReportTag.options.length = searchReportTag.options.length - optionCountDiff;
                }
            } else {
                rgTags.tags.push({
                    stag: ptag.stag,
                    inUse: false,
                    opt2: false,
                    limitedEdit: false,
                    options: ptag.options.map(tag => {
                        return({
                            inUse: false,
                            opt2: false,
                            limitedEdit: false,
                        });
                    })
                })
            }
        });
        rgTags.maxInd = maxInd;
        this.setState({rgTags: rgTags});
    }

    setRelativeTimeToState(attr, needSign) {
        // Set state from search obj where relative time is stored as ms offset
        let srchLimitString = prosConnect.getValidAttr(this.search, attr, STR_NO_VALUE)
        let change = {}
        if (srchLimitString === STR_NO_VALUE) {
            change[attr] = undefined
            change[attr+'_sign'] = -1
        } else {
            let offset = Math.round(parseInt(srchLimitString) / MS_IN_DAY)
            change[attr] = offset < 0 ? -offset : offset
            change[attr+'_sign'] = offset < 0 ? -1 : 1
        }
        // console.log('TO state', change)
        this.setState(change)
    }

    relativeTimesToState() {
        this.setRelativeTimeToState(RELATIVE_PREFIX_AFTER  + ATTR_CREATED_MS_I)
        this.setRelativeTimeToState(RELATIVE_PREFIX_BEFORE + ATTR_CREATED_MS_I)
        this.setRelativeTimeToState(RELATIVE_PREFIX_AFTER  + ATTR_UPDATED_MS_I)
        this.setRelativeTimeToState(RELATIVE_PREFIX_BEFORE + ATTR_UPDATED_MS_I)
        this.setRelativeTimeToState(RELATIVE_PREFIX_AFTER  + ATTR_EXPIRATION)
        this.setRelativeTimeToState(RELATIVE_PREFIX_BEFORE + ATTR_EXPIRATION)
    }

    getSearchSettings(project) {
        let searchId = this.props.searchId;
        let search = prosConnect.getObjById(searchId);
        this.getOnOffSearchSelections(project, search);
        this.getMultiValueSearchSelections(project, search);
        if (!search) {
            search = {text: ''}
        }
        this.search = search;
        this.setState({
            projectName: project.attrs.text,
        });
        if (search) {
            this.setState({
                searchReportName: search.text,
                filterByExpiration: isProsStrTrue(search[ATTR_EXPIRATION_FILTER]),
                isPrivate: isProsStrTrue(search[ATTR_IS_PRIVATE]),
            });
        }
        this.relativeTimesToState()
        this.setAdvancedSettings(this.search[ATTR_OBJ_TYPE] === OBJ_TYPE_LST_SEARCH_R)
        this.setAdvancedSettings(this.getReportFilterTime(ATTR_FILTER_CREATED_AFTER) > 0)
        this.setAdvancedSettings(this.getReportFilterTime(ATTR_FILTER_CREATED_BEFORE) > 0)
        this.setAdvancedSettings(this.getReportFilterTime(ATTR_FILTER_UPDATED_AFTER) > 0)
        this.setAdvancedSettings(this.getReportFilterTime(ATTR_FILTER_UPDATED_BEFORE) > 0)
        return true;
    }

    handleNameChange = val => {
        this.setState({
            searchReportName: val
        })
    }

    changeRbState(rbTag) {
        rbTag.inUse = !rbTag.inUse;
        this.setState({
            rgTags: this.state.rgTags
        })
    }

    changeOnOffState(chTag) {
        chTag.inUse = !chTag.inUse;
        this.setState({
            onOffTags: this.state.onOffTags,
        })
    }

    changeChState(chTag) {
        chTag.opt2 = !chTag.opt2;
        this.setState({
            onOffTags: this.state.onOffTags,
        })
    }

    canMultiSelectionOptionBeOngoing(stag, optionInd) {
        if (!this.state.filterByExpiration) {
            return true
        }
        let activeProject = prosConnect.getActiveProject()
        if (!activeProject.isStateSTag(stag))
            return true
        return activeProject.isProjectStateOngoing(optionInd)
    }

    renderChangeRbState(rgTag, rbTag, i, label) {
        let disabledByLateFilterInUse = !this.canMultiSelectionOptionBeOngoing(rgTag.stag, i)
        // disabledByLateFilterInUse is true when this is "state" and
        // state is not "ongoing"- i.e. state which never can be 'late'.
        return <Checkbox
            text={label}
            checked={rbTag.inUse && !disabledByLateFilterInUse}
            disabled={disabledByLateFilterInUse}
            onChange={()=> this.changeRbState(rbTag)}
            tooltip={disabledByLateFilterInUse ? "Estetty, koska 'Myöhässä'-asetus on päällä " : null}
        />
    }

    renderRbTags(projectTag, rgTag) {
        return projectTag.options.map(projectOption => {
            let optInUseInProject = getOption(projectTag, projectOption.optionIndex, 'inUse');
            if (projectOption.optionIndex < rgTag.options.length) {
                let rbTag = rgTag.options[projectOption.optionIndex]
                {
                    let label = optInUseInProject ? projectOption.label : projectOption.label + " (ei käytössä)"
                    return <React.Fragment key={'rgTag__' + projectOption.optionIndex}>
                        {this.renderChangeRbState(rgTag, rbTag, projectOption.optionIndex, label)}
                    </React.Fragment>
                }
            } else {
                prosConnect.prosLogErr("Invalid search rgTag:", rgTag)
                return null
            }
        })
    }

    renderOnOffInUse(chTag) {
        return <ToggleSwitch
            checked={chTag.inUse}
            onChange={() => this.changeOnOffState(chTag)}
        />
    }

    renderOnOffState(chTag) {
        return <ToggleSwitch
            checked={chTag.opt2}
            onChange={() => this.changeChState(chTag)}
            disabled={!chTag.inUse}
        />
    }

    renderOnOffButtons() {
        if (!this.state.onOffTags.tags) {
            return null
        }
        let onOffList = this.state.onOffTags.tags.map((onOff, i) => {
            let projectTag = this.projectOnOffTags.tags.find(tag => {return tag.stag === onOff.stag})
            if (!projectTag) {
                prosConnect.dumpActiveProjectAttrs("EDIT SEARCH CH:" + onOff.stag)
                return null
            }
            return <React.Fragment key={'onOff__' + i}>
                    <div>{this.renderOnOffInUse(onOff)}</div>
                    <div>{this.renderOnOffState(onOff)}</div>
                    <div>{projectTag.label}</div>
                </React.Fragment>
        })
        return <div className={"grid-container grid-flex-3"}>
                <div><p className={"text-sm"}>Käytä hakuehtona</p></div>
                <div><p className={"text-sm"}>Poissulje / Sisällytä</p></div>
                <div/>
                {onOffList}
            </div>
    }

    renderMultivalueOptions() {
        if (!this.state.rgTags.tags) {
            return null;
        }
        return this.state.rgTags.tags.map((rgTag, i) => {
            let projectTag = this.projectRgTags.tags.find(tag => {return tag.stag === rgTag.stag});
            if (!projectTag) {
                prosConnect.dumpActiveProjectAttrs("EDIT SEARCH RB:" + rgTag.stag);
                return null
            }
            let inUse = projectTag.inUse;
            return <div key={rgTag.stag} className={!inUse ? "disable-children" : null}>
                    <h3>{projectTag.label}</h3>
                    {this.renderRbTags(projectTag, rgTag)}
                </div>
        })
    }

    getReportFilterTime(timeTag) {
        let timeMs = prosConnect.hasAttr(this.search, timeTag) ? parseInt(this.search[timeTag]) : 0;
        return timeMs > MIN_EXPIRE_TIME_MS ? timeMs : 0;
    }

    valiReportTimeRange(after_attr, before_attr) {
        let timeAfterMs = this.getReportFilterTime(after_attr);
        let timeBeforeMs = this.getReportFilterTime(before_attr);
        if (timeBeforeMs === 0 && timeAfterMs === 0) {
            return true;
        }
        if (timeAfterMs < timeBeforeMs) {
            return true;
        }
        prosNotificationShow(this, 'Raportin aikaraja virheellinen', 'warning', true);
        return false;
    }

    promptTime(timeTag, title) {
        let timeMs = this.getReportFilterTime(timeTag);
        let refTime = timeMs > MIN_EXPIRE_TIME_MS ? timeMs : getEndOfWorkingDayTime(currentTimeMs());
        this.setState({
            datePickerTag: timeTag,
            datePickerTitle: title,
            refTime: refTime
        }, () => this.openPopupDatePicker());
    };

    renderCreated(timeTag, title) {
        let timeStr = this.search && this.search.hasOwnProperty(timeTag) ? this.search[timeTag] : "0"
        let timeMs = prosConnect.isValidAttr(timeStr) ? parseInt(timeStr) : 0
        let timeTxt = timeMs > prosConnect.MIN_EXPIRE_TIME_MS ? formatDate(parseInt(timeStr)) : '--.--.----'
        return <BasicButton
            btnClass={"2nd"}
            label={timeTxt}
            action={()=> this.promptTime(timeTag, title)}
            icon={"calendar"}
        />
    }

    toggleIsPrivateSearch() {
        let search = prosConnect.getObjById(this.props.searchId);
        if (!search || search[ATTR_CREATED_BY] === prosConnect.getUserEmail()) {
            // ok for a new or existing own search
            this.setState({isPrivate: !this.state.isPrivate });
        } else {
            prosNotificationShow(this, 'Vain tekijä itse voi merkitä henkilökohtaiseksi', 'warning');
        }
    }

    setRelativeTimeLimit(attr, limit) {
        let changedFromInvalidToValid = limit !== STR_NO_VALUE
        this.setAdvancedSettings(changedFromInvalidToValid)
        this.setState({ [attr]: limit })
    }

    renderPromptNumber(label, attr, mayBeInFuture= true) {
        // Relative time with label and number of days
        const MAX_DAYS_LIMIT = 5*365
        const maxValue = mayBeInFuture ? MAX_DAYS_LIMIT : 0
        const minValue = -MAX_DAYS_LIMIT
        let initialValue = this.state[attr]
        let initialSign = this.state[attr+'_sign']
        const preSelectedDays = {
            1: '1 päivä',
            7: '1 viikko',
            14: '2 viikkoa',
            30: '1 kuukausi',
            90: '3 kuukautta'
        }
        let menuItems = []
        for (const [k, v] of Object.entries(preSelectedDays)) {
            menuItems.push({key: k, value: k, text: v})
        }
        const manualInputObj = {
            type:         'number',
            title:        initialValue ? 'Päivien määrä' : null,
            placeholder:  'Kirjoita päivien määrä',
            info:         null,
            value:        initialValue,
            minValue:     minValue,
            maxValue:     maxValue,
            maxLength:    maxValue.length,
            onValueChange: retVal => this.setRelativeTimeLimit(attr, retVal),
            onValueSubmit: retVal => this.setRelativeTimeLimit(attr, retVal)
        }
        const selector = Math.abs(this.state[attr])
        const menuText = selector && attr !== STR_NO_VALUE
            ? (preSelectedDays[selector] ? preSelectedDays[selector] :  selector + ' päivää') : null

        const renderDropdown =()=>{
            return <DropdownMenu
                values={menuItems}
                currentValue={initialValue}
                onSelect={retVal => this.setRelativeTimeLimit(attr, retVal)}
                text={menuText}
                manualInput={manualInputObj}
                emptyValue={{value: STR_NO_VALUE, text: 'Ei valittu',}}
            />
        }

        const renderWithExpireSelector =()=> {
            if(!mayBeInFuture) return null
            const listItems = [{value: -1, text: 'Ennen nykyhetkeä'}, {key: 1, value: 1, text: 'Nykyhetken jälkeen'}]
            return <div className={"element-set"}>
                <DropdownMenu
                    className={"width-35_xl"}
                    values={listItems}
                    currentValue={initialSign}
                    onSelect={retVal => this.setState({ [attr+'_sign']: retVal })}
                />
                {renderDropdown()}
            </div>
        }

        return <div className={"element-set-v"}>
                <h4>{label}</h4>
                {mayBeInFuture ? renderWithExpireSelector() : renderDropdown()}
            </div>
    }

    setAdvancedSettings(isAdvancedSetting) {
        this.showAdvancedSettings |= isAdvancedSetting
    }

    renderPage() {
        return <>
                <section className={"search-settings project-settings"}>
                    <div className={"slab width-35_lg margin-top"}>
                        <h2>Hakuraportin nimi</h2>
                        <TextInput
                            value={this.state.searchReportName || ''}
                            onChange={(val)=> this.handleNameChange(val)}
                            isControlled
                            required
                            isValid={this.state.searchReportName.length > 0}
                        />
                    </div>
                    <div className={"slab"}>
                        <ToggleSwitch
                            label={'Henkilökohtainen haku, älä näytä muille.'}
                            checked={this.state.isPrivate}
                            onChange={()=> this.toggleIsPrivateSearch()}
                        />
                    </div>
                    <div className={"slab"}>
                        <h2>Hakuehdot</h2>
                        <p>Hakuehdot voidaan tallentaa myöhempää käyttöä varten.<br />
                            Haku palauttaa kirjaukset ja niihin liittyvät lisätiedot
                            sekä raportin, joille kirjaukset on kirjattu.</p>
                    </div>
                    <div className={"slab"}>
                        <h3>MYÖHÄSSÄ</h3>
                        <ToggleSwitch
                            label={'Osaprojektin asetusten mukaan tila on "kesken" ja määräaika ylitetty'}
                            checked={this.state.filterByExpiration}
                            onChange={()=> this.setState({filterByExpiration: !this.state.filterByExpiration})}
                        />
                    </div>
                    <div className={"slab"}>
                        <h3>Kyllä/ei valinnat</h3>
                        <p>Valitse käytetäänkö valintaa hakuehtona.<br />
                        Poissulje suodattaa ehtoa vastaavat tulokset pois hausta. Sisällytä näyttää ne tuloksissa.</p>
                        {this.renderOnOffButtons()}
                    </div>
                    <div className={"slab width-70_xl"}>
                        <h3>Monivalinnat</h3>
                        <p className={"instructions"}>Haku etsii valitut monivalinnan ehdot raporttiin.<br />
                            Monivalintaa ei huomioida haussa, kun yksikään vaihtoehdoista ei ole valittu.</p>
                        <div className={"grid-container grid-2"}>
                            {this.renderMultivalueOptions()}
                        </div>
                    </div>
                    <div className={"slab width-70_xl"}>
                        <AccordionDropdown key={'accordion__advanced'}
                           header={<h3>Edistyneet valinnat</h3>}
                           dynamicOpen={this.showAdvancedSettings}
                        >
                            <h3>Aikarajat</h3>
                            <div className={"grid-container grid-2"}>
                                <div className={"element-set-v"}>
                                    <h4>Kirjattu päivämäärän jälkeen</h4>
                                    {this.renderCreated(ATTR_FILTER_CREATED_AFTER, "alku")}
                                </div>
                                <div className={"element-set-v"}>
                                    <h4>Kirjattu päivämäärää ennen</h4>
                                    {this.renderCreated(ATTR_FILTER_CREATED_BEFORE, "loppu")}
                                </div>
                                <div className={"element-set-v"}>
                                    <h4>Muokattu päivämäärän jälkeen</h4>
                                    {this.renderCreated(ATTR_FILTER_UPDATED_AFTER, "alku")}
                                </div>
                                <div className={"element-set-v"}>
                                    <h4>Muokattu päivämäärää ennen</h4>
                                    {this.renderCreated(ATTR_FILTER_UPDATED_BEFORE, "loppu")}
                                </div>
                            </div>
                            <Spacer size={"lg"}/>
                            <h3>Aikarajaus suhteessa haku- / nykyhetkeen </h3>
                            <p>Aikaraja / ero nykyhetkeen asetetaan päivien lukumäärä. Luonti- ja muutosajalle aikaero on ennen nykyhetkeä,
                                mutta määräajalle valitaan onko aikaero päivinä nykyhetkeen ennen vai jälkeen.</p>
                            <p>
                                Esimerkki-1: Määräaika alku: 30 päivää ja Loppu: 7 päivää:<br/>
                                Otetaan mukaan ne kirjaukset, jotka ovat jo erääntyneet kuukausi sitten sekä erääntyvät seuraavan viikon kuluessa.</p>
                            <p>
                                Esimerkki-2: Luonti alku: 14 päivää, loppu ei valintaa:<br/>
                                Otetaan mukaan edellisen kahden viikon aikana tehdyt kirjaukset.
                            </p>
                            <div className={"grid-container grid-2"}>
                                {this.renderPromptNumber("Luontiaika alku", RELATIVE_PREFIX_AFTER + ATTR_CREATED_MS_I, false, 'creationDateStart')}
                                {this.renderPromptNumber("Loppu", RELATIVE_PREFIX_BEFORE + ATTR_CREATED_MS_I, false, 'creationDateEnd')}
                            </div>
                            <div className={"grid-container grid-2"}>
                                {this.renderPromptNumber("Muokattu alku", RELATIVE_PREFIX_AFTER + ATTR_UPDATED_MS_I, false, 'modifiedDateStart')}
                                {this.renderPromptNumber("Loppu", RELATIVE_PREFIX_BEFORE + ATTR_UPDATED_MS_I, false, 'modifiedDateEnd')}
                            </div>
                            <div className={"grid-container grid-2"}>
                                {this.renderPromptNumber("Määräaika alku", RELATIVE_PREFIX_AFTER + ATTR_EXPIRATION, true, 'expireDateStart')}
                                {this.renderPromptNumber("Loppu", RELATIVE_PREFIX_BEFORE + ATTR_EXPIRATION, true, 'expireDateEnd')}
                            </div>
                        </AccordionDropdown>
                    </div>
                    <div className={"sub-container"}>
                        <ProsUpdateInfo prosObj={this.search}/>
                    </div>
                </section>
            </>
    }

    removeOldTags() {
        if (!this.search) {
            return {}
        }
        let project = prosConnect.getActiveProject();
        let oldOnOffTags = project.getOnOffContent(this.search);
        oldOnOffTags.tags.forEach(tag => {
            delete this.search[tag.stag];
        });
        let oldRgTags = project.getMultiValueContent(this.search);
        oldRgTags.tags.forEach(tag => {
            delete this.search[tag.stag];
        });
        return this.search;
    }

    saveChanges(objId) {
        if (isProsStringEmpty(this.state.searchReportName)) {
            prosNotificationShow(this, 'Nimi puuttuu', 'warning', true);
            return
        }
        if (!this.valiReportTimeRange(ATTR_FILTER_CREATED_AFTER, ATTR_FILTER_CREATED_BEFORE)) {
            return;
        }
        if (!this.valiReportTimeRange(ATTR_FILTER_UPDATED_AFTER, ATTR_FILTER_UPDATED_BEFORE)) {
            return;
        }
        let searchObj = this.removeOldTags();
        this.state.onOffTags.tags.forEach(onOff => {
            searchObj[onOff.stag] = "x;" +
                strYesNoValue(onOff.inUse) + ";" +
                strYesNoValue(onOff.opt2);
        });
        this.state.rgTags.tags.forEach(rgTag => {
            let str = "x";
            rgTag.options
                .sort((a,b) => a.uiOrder-b.uiOrder)
                .forEach(option => {
                    let allowedByLateOption = this.canMultiSelectionOptionBeOngoing(rgTag.stag, option.optionIndex)
                    str += ';;x;' + strYesNoValue(option.inUse && allowedByLateOption)
                })
            searchObj[rgTag.stag] = str;
            return searchObj;
        });

        searchObj[ATTR_EXPIRATION_FILTER] = strYesNoValue(this.state.filterByExpiration);
        searchObj[prosConnect.ATTR_TEXT] = this.state.searchReportName;
        searchObj[ATTR_OBJ_TYPE] = prosConnect.OBJ_TYPE_LST_SEARCH;
        searchObj[ATTR_IS_PRIVATE] = strYesNoValue(this.state.isPrivate);

        let hasRelativeFilters = false


        function isRelativeOffsetValid(self, attr, what) {
            let offsetAfter = prosConnect.getValidAttr(self.state, RELATIVE_PREFIX_AFTER+attr, STR_NO_VALUE)
            let offsetBefore = prosConnect.getValidAttr(self.state,RELATIVE_PREFIX_BEFORE+attr, STR_NO_VALUE)
            if (offsetAfter === STR_NO_VALUE || offsetBefore === STR_NO_VALUE){
                return true
            }
            let after = self.state[RELATIVE_PREFIX_AFTER+attr+'_sign'] * self.state[RELATIVE_PREFIX_AFTER+attr]
            let before = self.state[RELATIVE_PREFIX_BEFORE+attr+'_sign'] * self.state[RELATIVE_PREFIX_BEFORE+attr]
            let valid = after < before
            // console.log("after:", after, "before:", before)
            if (!valid) {
                prosNotificationShow(self, 'Suhteellinen aikaraja ' + what
                    + ' virheellinen. Alkuaika pitää olla ennen loppuaikaa', 'warning', true)
            }
            return valid
        }

        let relativeOffsetValid = isRelativeOffsetValid(this, ATTR_CREATED_MS_I, 'luontiaika')
        relativeOffsetValid &= isRelativeOffsetValid(this, ATTR_UPDATED_MS_I, 'muutosaika')
        relativeOffsetValid &= isRelativeOffsetValid(this, ATTR_EXPIRATION, 'määräaika')
        if (!relativeOffsetValid) {
            return
        }

        function getFromState(state, attr) {
            if (state[attr] === undefined || state[attr] === STR_NO_VALUE) {
                searchObj[attr] = STR_NO_VALUE
                // console.log('from state', attr, '->', searchObj[attr])
            } else {
                let offset = state[attr]
                let sign = state[attr + '_sign']
                searchObj[attr] = (sign * offset * MS_IN_DAY).toString()
                hasRelativeFilters = true
                // console.log('from state', attr, 'offset:', offset, 'sign:', sign, '->', searchObj[attr])
            }
        }

        getFromState(this.state, RELATIVE_PREFIX_AFTER  + ATTR_CREATED_MS_I)
        getFromState(this.state, RELATIVE_PREFIX_BEFORE + ATTR_CREATED_MS_I)
        getFromState(this.state, RELATIVE_PREFIX_AFTER  + ATTR_UPDATED_MS_I)
        getFromState(this.state, RELATIVE_PREFIX_BEFORE + ATTR_UPDATED_MS_I)
        getFromState(this.state, RELATIVE_PREFIX_AFTER  + ATTR_EXPIRATION)
        getFromState(this.state, RELATIVE_PREFIX_BEFORE + ATTR_EXPIRATION)

        // Make search obj type as relative when any of the relatime filters been set
        // Needed to prevent a search that has "relative time filters" be shown in mobile app
        // backwards compliancy as not implemented yet (in 6/2022) to mobile app
        searchObj[ATTR_OBJ_TYPE] = hasRelativeFilters ? OBJ_TYPE_LST_SEARCH_R : OBJ_TYPE_LST_SEARCH
        // console.log(searchObj)

        if (objId === "newSearch") {
            this.saveChangesToServer(searchObj);
        } else {
            if (objId) {
                searchObj[prosConnect.ATTR_OBJ_ID] = objId;
                this.updateChangesToServer(searchObj);
            }
        }
        this.props.switchToReportView()
    }

    async updateChangesToServer(itm) {
        let project = prosConnect.getActiveProject();
        if (project) {
            await project.awaitUpdateItem(itm, true);
        }
    }

    async saveChangesToServer(itm) {
        let project = prosConnect.getActiveProject();
        if (project) {
            await project.awaitAddObject(itm);
        }
    }


    checkAuthority() {
        return prosConnect.hasPermissionTo("editProject", undefined, undefined, false)
    }

    hideDatePicker() {
        prosPopupClose()
        this.setState( {datePickerTag: undefined})
    }

    removeTimeLimit() {
        this.search[this.state.datePickerTag] = STR_NO_VALUE;
        this.hideDatePicker();
    }

    setTimeLimit = (date) => {
        let timeMs = date.getTime()
        // prosConnect.dumpTime(this.state.datePickerTag, timeMs);
        let adjustedTimeMs = timeMs
        if (this.state.datePickerTag in [ATTR_FILTER_CREATED_BEFORE, ATTR_FILTER_UPDATED_BEFORE]) {
            adjustedTimeMs = adjustDateToClock(timeMs, false)
        } else if (this.state.datePickerTag in [ATTR_FILTER_CREATED_AFTER, ATTR_FILTER_UPDATED_AFTER]) {
            adjustedTimeMs = adjustDateToClock(timeMs,true)
        }
        // console.log("this.state.datePickerTag:", this.state.datePickerTag,
        //    formatDate(timeMs, true), "->", formatDate(adjustedTimeMs, true))
        this.search[this.state.datePickerTag] = adjustedTimeMs.toString();
        this.setState({refTime: timeMs});
        this.hideDatePicker();
        this.valiReportTimeRange(ATTR_FILTER_CREATED_AFTER, ATTR_FILTER_CREATED_BEFORE)
        this.valiReportTimeRange(ATTR_FILTER_UPDATED_AFTER, ATTR_FILTER_UPDATED_BEFORE)
    };

    openPopupDatePicker() {
        let title = 'Aseta aika ' + this.state.datePickerTitle
        prosPopupOpen(this,
            title,
            <>
                <section>
                    <Calendar
                        onChange={this.setTimeLimit}
                        value={utcToLocalTime(this.state.refTime)}
                        locale="fi-FI"
                    />
                </section>
                <footer className={"popup-footer"}>
                    <div className={"btn-set"}>
                        <CancelButton
                            action={()=> this.hideDatePicker()}
                        />
                        <ConfirmButton
                            btnType={"fatal"}
                            action={()=> this.removeTimeLimit()}
                        />
                    </div>
                </footer>
            </>,
            () => this.hideDatePicker()
        )
    }

    render() {
        if (!prosConnect.getActiveProject()) {
            return <header className="page-header">
                <h1>Lataa projekti</h1>
            </header>
        }
        if (!this.checkAuthority()) {
            return <header className="page-header">
                <h1>Ei käyttöoikeutta tässä osaprojektissa</h1>
            </header>
        }
        return <>
            <header className="page-header">
                <h1>{this.props.searchId === 'newSearch' ? 'Luo haku' : 'Muokkaa hakua'}</h1>
                <button
                    onClick={this.props.switchToReportView}
                    className={"btn btn-primary btn-icon btn-icon-left btn-icon-arrow-left"}
                ><span>Takaisin</span></button>
            </header>
            {this.renderPage()}
            <footer className={"page-footer"}>
                <div className={"btn-set_center"}>
                    <CancelButton
                        action={()=> this.props.switchToReportView()}
                    />
                    <ConfirmButton
                        action={()=> this.saveChanges(this.props.searchId)}
                    />
                </div>
            </footer>
        </>
    }
}
